import React from 'react';
import { Col, Form, Input, Radio, Row } from 'antd';
import ConditionalFormItem from '../../ConditionalFormItem';
import { FormInstance } from 'antd/es/form/hooks/useForm';

/**
 * 申请人信息分区
 * 包含：申请人/最新权利人、申请人地址、申请人英文名字、申请人英文地址
 */
interface ApplicantInfoSectionProps {
  /** 表单实例 */
  form: FormInstance<any>;
  /** 是否编辑模式（当前仅影响只读样式） */
  isEdit?: boolean;
  /** 统一的只读样式获取函数 */
  getReadOnlyProps?: (fieldType?: 'input' | 'select') => any;
}

const ApplicantInfoSection: React.FC<ApplicantInfoSectionProps> = ({ form, isEdit = false, getReadOnlyProps }) => {
  const readOnlyProps = getReadOnlyProps || (() => ({}));
  return (
    <>
    <ConditionalFormItem condition="sub_service == registration || sub_service == transactions || sub_service == appearance_application || sub_service == invention_application || sub_service == appearance_application || sub_service == utility_application || sub_service == authorization">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="申请主体类型" name="application_entity_type" initialValue={"公司申请"}>
            <Radio.Group>
              <Radio value="公司申请">公司申请</Radio>
              <Radio value="个人申请">个人申请</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
    </ConditionalFormItem>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="申请人/权利人/持有人中文名" name="applicant_name">
            <Input placeholder="证件照上的名字/中文名（可选）" data-testid="order-applicant-name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="申请人/权利人/持有人英文名" name="applicant_name_en">
            <Input placeholder="证件照上英文名（可选）" data-testid="order-applicant-name-en" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <ConditionalFormItem condition="sub_service == registration || sub_service == transactions || sub_service == transfer || sub_service == investment || sub_service == information_changes || sub_service == appearance_application || sub_service == invention_application || sub_service == utility_application">
            <Form.Item label="申请人/权利人/持有人地址" name="applicant_address">
              <Input placeholder="证件照上的地址（可选）" data-testid="order-applicant-address" />
            </Form.Item>
          </ConditionalFormItem>
        </Col>
        <Col span={24}>
          <ConditionalFormItem condition="sub_service == registration || sub_service == transactions || sub_service == transfer || sub_service == investment || sub_service == information_changes || sub_service == appearance_application || sub_service == invention_application || sub_service == utility_application">
          <Form.Item label="申请人/权利人/持有人英文地址" name="applicant_address_en">
            <Input placeholder="英文地址（可选）" data-testid="order-applicant-address-en" />
          </Form.Item>
          </ConditionalFormItem>
        </Col>
      </Row>
    </>
  );
};

export default ApplicantInfoSection;
